module.exports = __webpack_public_path__ + "assets/img/img-detail-sp.19b50ab0.jpg";